import {
    type GetMemberTableInfoResponseType,
    type GetMemberTableInfoRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetMemberTableInfo = async (params: GetMemberTableInfoRequestType): Promise<GetMemberTableInfoResponseType> => {
    return await axios(`${SERVER_ADDRESS}/threeT/getMemberTableInfo`, {
        method: "GET",
        headers: getHeaders(),
        params: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default GetMemberTableInfo;
